<div class="width-1100">

    <mat-card>
        <mat-toolbar class="toolbar-top">

            <div class='title'>
                <mat-icon>list</mat-icon>
                <div>Inscrições Streaming</div>
            </div>

            <div flex justify-content='flex-end' fxLayoutAlign="end">
                <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro'
                    autocomplete="off">

            </div>

        </mat-toolbar>

    </mat-card>

    <mat-card id='table-body'>

        <mat-tab-group>

            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class='tab-icon'>star</mat-icon>
                    <div>{{count}} Inscritos</div>
                </ng-template>

                <div class='tab-content'>

                    <!-- TABLE -->
                    <mat-table [dataSource]="dataSource" matSort matSortActive="date" matSortDirection='desc'
                        matSortDisableClear=true>

                        <!-- Icon Column -->
                        <ng-container matColumnDef="icon">
                            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                <mat-icon style='font-size:1.2em; margin-top:10px;'>list</mat-icon>
                            </mat-cell>
                        </ng-container>

                        <!-- date Column -->
                        <ng-container matColumnDef="date">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Data </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{ element.date.seconds*1000 | date: 'dd/MM/yyyy HH:mm'
                                }}
                            </mat-cell>
                        </ng-container>

                        <!-- name Column -->
                        <ng-container matColumnDef="name">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
                        </ng-container>

                        <!-- valid Email Column -->
                        <ng-container matColumnDef="validEmail">
                            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                <img *ngIf='element.validEmail' src='/assets/images/status/img_green.png'>
                                <img *ngIf='!element.validEmail' src='/assets/images/status/img_red.png'>
                            </mat-cell>
                        </ng-container>

                        <!-- email Column -->
                        <ng-container matColumnDef="email">
                            <mat-header-cell *matHeaderCellDef> Email </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{ element.email }} </mat-cell>
                        </ng-container>

                        <!-- valid CPF Column -->
                        <ng-container matColumnDef="validCPF">
                            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                <img *ngIf='element.validCPF' src='/assets/images/status/img_green.png'>
                                <img *ngIf='!element.validCPF' src='/assets/images/status/img_red.png'>
                            </mat-cell>
                        </ng-container>

                        <!-- CPF Column -->
                        <ng-container matColumnDef="cpf">
                            <mat-header-cell *matHeaderCellDef> CPF </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{ element.cpf }} </mat-cell>
                        </ng-container>


                        <!-- Export Column -->
                        <ng-container matColumnDef="export">
                            <mat-header-cell *matHeaderCellDef>
                                <button mat-button style='width:60px;' (click)="exportToCsv(true)">
                                    <mat-icon class='icon-close'>arrow_circle_down</mat-icon>
                                </button>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element"> </mat-cell>
                        </ng-container>

                        <!-- Header -->
                        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

                        <!-- Row -->
                        <mat-row *matRowDef="let row; columns: displayedColumns;" (click)='openDialog(row)'></mat-row>

                    </mat-table>
                    <!-- END TABLE -->
                </div>
            </mat-tab>

            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class='tab-icon'>mic</mat-icon>
                    <div>{{countStaff}} Palestrantes</div>
                </ng-template>

                <div class='tab-content'>

                    <!-- TABLE -->
                    <mat-table [dataSource]="dataSourceStaff">

                        <!-- Icon Column -->
                        <ng-container matColumnDef="icon">
                            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                <mat-icon style='font-size:1.2em; margin-top:10px;'>list</mat-icon>
                            </mat-cell>
                        </ng-container>

                        <!-- date Column -->
                        <ng-container matColumnDef="date">
                            <mat-header-cell *matHeaderCellDef> Data </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{ element.date.seconds*1000 | date: 'dd/MM/yyyy HH:mm'
                                }}
                            </mat-cell>
                        </ng-container>

                        <!-- name Column -->
                        <ng-container matColumnDef="name">
                            <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
                            <mat-cell *matCellDef="let element">

                                <div style='display:flex; flex-direction:column;'>
                                    <div>
                                        <b>{{ element.name }}</b>
                                    </div>
                                    <div>
                                        {{ element.event }}
                                    </div>
                                    <!--
                                    <div>
                                        <ul>
                                            <li> {{ element.event }}</li>
                                            <li>{{ element.activity }}</li>
                                            <li>{{ element.topic }}</li>
                                        </ul>
                                    </div>
                                    -->
                                </div>

                            </mat-cell>
                        </ng-container>


                        <!-- email Column -->
                        <ng-container matColumnDef="email">
                            <mat-header-cell *matHeaderCellDef> Email </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{ element.email }} </mat-cell>
                        </ng-container>


                        <!-- valid Email Column -->
                        <ng-container matColumnDef="validEmail">
                            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                <img *ngIf='element.validEmail' src='/assets/images/status/img_green.png'>
                                <img *ngIf='!element.validEmail' src='/assets/images/status/img_red.png'>
                            </mat-cell>
                        </ng-container>

                        <!-- CPF Column -->
                        <ng-container matColumnDef="cpf">
                            <mat-header-cell *matHeaderCellDef> CPF </mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{ element.cpf }} </mat-cell>
                        </ng-container>


                        <!-- valid CPF Column -->
                        <ng-container matColumnDef="validCPF">
                            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                <img *ngIf='element.validCPF' src='/assets/images/status/img_green.png'>
                                <img *ngIf='!element.validCPF' src='/assets/images/status/img_red.png'>
                            </mat-cell>
                        </ng-container>

                        <!-- Export Column -->
                        <ng-container matColumnDef="export">
                            <mat-header-cell *matHeaderCellDef>
                                <button mat-button style='width:60px;' (click)="exportToCsv(false)">
                                    <mat-icon class='icon-close'>arrow_circle_down</mat-icon>
                                </button>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let element"> </mat-cell>
                        </ng-container>

                        <!-- Header -->
                        <mat-header-row *matHeaderRowDef="displayedColumnsStaff"></mat-header-row>

                        <!-- Row (click)='openDialog(row)'-->
                        <mat-row *matRowDef="let row; columns: displayedColumnsStaff;" >
                        </mat-row>

                    </mat-table>
                    <!-- END TABLE -->
                </div>
            </mat-tab>

        </mat-tab-group>

    </mat-card>

</div>